export default "__VITE_ASSET__4be3b3e9__"